import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TemplateDocumentButton } from '../../../../components/TemplateDocumentButton/TemplateDocumentButton';
import { useSupervisionContext } from '../../../../contexts/SupervisionContext/SupervisionContext';
import { templateDocumentFileName } from '../../../../utils/templateDocumentFileName';

/**
 * Shared button to generate supervision synthesis. Used by BookedButtons, FinishedButtons, WaitingBookingButtons.
 * The downloaded filename includes the supervision reference, read from SupervisionContext.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.supervisionId - The ID of the supervision.
 * @returns {JSX.Element} The generated synthesis button.
 */
export const GenerateSynthesisButton = ({ supervisionId }) => {
  const { t } = useTranslation();
  const { state: { supervision } = {} } = useSupervisionContext();
  const { reference } = supervision || {};

  return (
    <TemplateDocumentButton
      parameters={[{ collection: 'Supervision', documentId: supervisionId }]}
      use_case="SUPERVISION_SUMMARY"
      extraQuery="template_type=TEMPLATE_DOCS"
      buttonType="primary"
      button_text="supervisions.show.buttons.generate_synthesis"
      downloadName={templateDocumentFileName({
        t,
        useCase: 'SUPERVISION_SUMMARY',
        reference
      })}
    />
  );
};

GenerateSynthesisButton.propTypes = {
  supervisionId: PropTypes.string
};

GenerateSynthesisButton.defaultProps = {
  supervisionId: null
};
